import { Option } from 'baseui/select';
import { ColumnDataType, IColumn } from 'components/elements/table/type';
import useTranslation from 'next-translate/useTranslation';
import React from 'react';

import { CruiseSaleCruiseSaleGuestFormType } from '../../form-type';

export default function useGetCruiseGroupDetailTableList(
  cruiseRoomList: Option[],
) {
  const { t } = useTranslation();
  const columns = React.useMemo<
    IColumn<CruiseSaleCruiseSaleGuestFormType>[]
  >(() => {
    return [
      {
        header: t('cruise:cabin'),
        accessorKey: 'cruiseRoomId',
        minSize: 180,
        maxSize: 200,
        dataType: ColumnDataType.select,
        options: cruiseRoomList,
        required: true,
      },
      {
        header: t('cruise:cabin_number'),
        accessorKey: 'cruiseRoomNumber',
        minSize: 180,
        maxSize: 200,
        dataType: ColumnDataType.text,
        required: true,
      },
      {
        header: t('cruise:deck'),
        accessorKey: 'deck',
        minSize: 180,
        maxSize: 200,
        dataType: ColumnDataType.text,
        required: true,
      },
      {
        header: t('ticketSales:basic_fare'),
        accessorKey: 'basicFare',
        minSize: 150,
        maxSize: 150,
        dataType: ColumnDataType.number,
        minNumber: 0,
        required: true,
      },
      {
        header: t('ticketSales:port_charge'),
        accessorKey: 'portCharge',
        minSize: 150,
        maxSize: 150,
        dataType: ColumnDataType.number,
        minNumber: 0,
        required: true,
      },
      {
        header: t('ticketSales:tax'),
        accessorKey: 'tax',
        minSize: 150,
        maxSize: 150,
        dataType: ColumnDataType.number,
        minNumber: 0,
        required: true,
      },
      {
        header: t('ticketSales:tipping'),
        accessorKey: 'tipping',
        minSize: 150,
        maxSize: 150,
        dataType: ColumnDataType.number,
        minNumber: 0,
        required: true,
      },
      {
        header: t('cruise:reservation_number'),
        accessorKey: 'description',
        minSize: 180,
        dataType: ColumnDataType.text,
      },
    ];
  }, [cruiseRoomList, t]);

  return columns;
}
